import { Flex, Text } from '@servicetitan/anvil2';
import { Calculation, PaymentFrequency } from '@servicetitan/financing-api-client';
import { formatCurrency } from '@servicetitan/financing-utils-shared';
import { useProviderConfig } from '@servicetitan/financing-workflow-shared';

interface PaymentProps {
    plan: Calculation;
    isPromoStart?: boolean;
    eyebrowText?: string;
    currentFrequency?: PaymentFrequency;
}

export const Payment = ({
    plan,
    isPromoStart = false,
    eyebrowText = '',
    currentFrequency,
}: PaymentProps) => {
    const { termMultiplier, enablePaymentFrequencyTabs } = useProviderConfig();

    // Get payment term text based on frequency for Financeit provider
    const getPaymentTermText = () => {
        if (enablePaymentFrequencyTabs && currentFrequency) {
            switch (currentFrequency) {
                case PaymentFrequency.Weekly:
                    return '/week.';
                case PaymentFrequency.BiWeekly:
                    return '/bi-weekly.';
                case PaymentFrequency.Monthly:
                default:
                    return '/mo.';
            }
        }
        return '/mo.';
    };

    return (
        <Flex direction="column" gap="3">
            <Text variant="eyebrow" style={{ minHeight: '1rem' }}>
                {eyebrowText}
            </Text>
            <Flex direction="column" gap="half">
                <div style={{ whiteSpace: 'nowrap' }}>
                    <Text variant="body" size="large" inline style={{ lineHeight: 0.5 }}>
                        <strong style={{ lineHeight: 0.5 }}>
                            {formatCurrency(
                                isPromoStart
                                    ? plan.promotionalMonthlyPayment!
                                    : plan.defaultMonthlyPayment!,
                            )}
                        </strong>
                    </Text>
                    <Text variant="body" inline>
                        {getPaymentTermText()}
                    </Text>
                </div>
                <Text variant="body" size="small">
                    {isPromoStart ? 'first ' : 'for '}
                    <strong>
                        {isPromoStart ? plan.promotionalTerms : plan.defaultTerms * termMultiplier}{' '}
                        months
                    </strong>
                </Text>
            </Flex>
        </Flex>
    );
};
